const IOS_AUTH_ALLOWED_PATHS = new Set(['/signup', '/login', '/logout', '/start']);

function normalizePathname(pathname = '/') {
  if (!pathname || pathname === '/') {
    return '/';
  }

  return pathname.replace(/\/+$/, '');
}

export function isIosAuthFlow(search = '') {
  const query = new URLSearchParams(search);
  return query.get('from') === 'ios' && query.get('action') === 'auth';
}

export function isIosAuthAllowedPath(pathname = '/') {
  const normalizedPathname = normalizePathname(pathname);
  return normalizedPathname.startsWith('/reset-password') || IOS_AUTH_ALLOWED_PATHS.has(normalizedPathname);
}

export function getIosAuthMode({ pathname = '/', search = '', hasAccount = false } = {}) {
  if (!isIosAuthFlow(search) || isIosAuthAllowedPath(pathname)) {
    return null;
  }

  return hasAccount ? 'redirect' : 'login';
}

export function getIosAuthRedirectUrl(apiKey) {
  return `nextdns://?apiKey=${encodeURIComponent(apiKey)}`;
}
